import React, { ReactElement } from "react";

import modStyl from './index.module.scss'
import { useHistory } from "react-router-dom";
import LazyIcon from "../../../components/lazy-icon";

type Item = {
  key: number
  label: string
  icon: ReactElement
  href?: string
  onClick?: ()=> void
}
type Props = {
  items: Item[]
}
const Cell: React.FC<Props> = ({ items })=> {
  const his = useHistory()
  const onClick = (item: Item)=> {
    if (typeof item.onClick === 'function') {
      item.onClick()
    } else if (typeof item.href === 'string') {
      if (/^https?:\/\//.test(item.href)) {
        window.location.href = item.href
      } else {
        his.push(item.href)
      }
    }
  }
  return (
    <ul className={modStyl.wrapper}>
      {
        items.map((item)=> (
          <li key={item.key}>
            <button onClick={() => onClick(item)} type="button">
              <div className={modStyl.wt}>
                {item.icon}
                <span>{item.label}</span>
              </div>
              <div className={modStyl.et}>
                <LazyIcon name="arrow-right"/>
              </div>
            </button>
          </li>
        ))
      }
    </ul>
  )
}

export default Cell